module.exports = __webpack_public_path__ + "img/mbanner4_tv.5215bc82.jpg";